<template>
  <div id="main-screen" style="overflow:hidden;">
    <div class="main-content"  style="overflow:auto;">
      <div class="main-left">
        <div class="left-total">
          <div class="left-total-title">总设备统计</div>
          <div class="left-total-item">
            <dv-border-box13>
              <div class="left-item-block">
                <div class="left-itemBlock-container">
                  <span class="left-container-name">总设备</span>
                </div>
                <div class="left-itemBlock-container">
                  <span class="left-container-value">{{totalDevice}}</span>
                </div>
              </div>

              <dv-decoration-2 class="left-item-line"/>

              <div class="left-item-block">
                <div class="left-itemBlock-container">
                  <span class="left-container-name">在线设备</span>
                </div>
                <div class="left-itemBlock-container">
                  <span class="left-container-value">{{onTotalDevice}}</span>
                </div>
              </div>

              <dv-decoration-2 class="left-item-line" />

              <div class="left-item-block">
                <div class="left-itemBlock-container">
                  <span class="left-container-name">离线设备</span>
                </div>
                <div class="left-itemBlock-container">
                  <span class="left-container-value">{{offTotalDevice}}</span>
                </div>
              </div>
            </dv-border-box13>
          </div>
        </div>

        <div class="left-device">
          <div class="left-device-title">设备统计</div>
          <div class="left-device-main">
            <dv-border-box13>
              <div class="left-main-item" v-for="(item, index) in leftData" :key="index">
                <div class="left-item-subTitle">{{item.name}}</div>
                <div class="left-item-device">
                  <div class="left-itemDevice-name">
                    <span class="left-itemDevice-nameContainer">{{item.deviceName}}</span>
                  </div>
                  <div class="left-itemDevice-value">
                    <span class="left-itemDevice-valueContainer">{{item.deviceNum}}</span>
                  </div>
                </div>
                <div class="left-item-device">
                  <div class="left-itemDevice-name">
                    <span class="left-itemDevice-nameContainer">{{item.onLineName}}</span>
                  </div>
                  <div class="left-itemDevice-value">
                    <span class="left-itemDevice-valueContainer">{{item.onLineNum}}</span>
                  </div>
                </div>
                <div class="left-item-device">
                  <div class="left-itemDevice-name">
                    <span class="left-itemDevice-nameContainer">{{item.offLineName}}</span>
                  </div>
                  <div class="left-itemDevice-value">
                    <span class="left-itemDevice-valueContainer">{{item.offLineNum}}</span>
                  </div>
                </div>
                <dv-decoration2 v-if="index != leftData.length - 1" class="left-item-line" />
              </div>

            </dv-border-box13>
          </div>
        </div>
      </div>

      <div class="main-middle">
        <map-data ref="mapData"/>
      </div>

      <div class="main-right" >
        <div class="right-device">
          <div class="right-device-title">设备统计</div>
          <div class="right-device-main">
            <dv-border-box13>
              <div class="right-main-item" v-for="(item, index) in rightData" :key="index">
                <div class="right-item-subTitle">{{item.name}}</div>
                <div class="right-item-device">
                  <div class="right-itemDevice-name">
                    <span class="right-itemDevice-nameContainer">{{item.deviceName}}</span>
                  </div>
                  <div class="right-itemDevice-value">
                    <span class="right-itemDevice-valueContainer">{{item.deviceNum}}</span>
                  </div>
                </div>
                <div class="right-item-device">
                  <div class="right-itemDevice-name">
                    <span class="right-itemDevice-nameContainer">{{item.onLineName}}</span>
                  </div>
                  <div class="right-itemDevice-value">
                    <span class="right-itemDevice-valueContainer">{{item.onLineNum}}</span>
                  </div>
                </div>
                <div class="right-item-device">
                  <div class="right-itemDevice-name">
                    <span class="right-itemDevice-nameContainer">{{item.offLineName}}</span>
                  </div>
                  <div class="right-itemDevice-value">
                    <span class="right-itemDevice-valueContainer">{{item.offLineNum}}</span>
                  </div>
                </div>
                <dv-decoration-2 class="right-item-line"/>
              </div>

              <div class="right-main-seed" v-if="seedShow">
                <div class="right-seed-name">
                  <span class="right-seed-nameContainer">苗情设备</span>
                </div>
                <div class="right-seed-value">
                  <span class="right-seed-valueContainer">{{seedDevice}}</span>
                </div>
              </div>
            </dv-border-box13>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mapData from "./MapData"
  import moment from "moment"
  import {getAttributesShared} from "../../until/api/MeteSoil";
  import {pestDeviceState} from "../../until/api/SporePest";
  import {insectDevice} from "../../until/api/inesctPest";
  export default {
    name: 'MainScreen',
    components:{
      mapData
    },
    data() {
      return {
        rightData:[],
        leftData: [],
        customerId: '',
        totalDevice: 0,
        onTotalDevice: 0,
        offTotalDevice: 0,
        meteDevice: 0,
        onMeteDevice: 0,
        offMeteDevice: 0,
        soilDevice: 0,
        onSoilDevice: 0,
        offSoilDevice: 0,
        fxscdDevice: 0,
        onFxscdDevice: 0,
        offFxscdDevice: 0,
        pestDevice: 0,
        onPestDevice: 0,
        offPestDevice: 0,
        sporeDevice: 0,
        onSporeDevice: 0,
        offSporeDevice: 0,
        sporeArray: [],
        mouseDevice: 0,
        onMouseDevice: 0,
        offMouseDevice: 0,
        targetDevice: 0,
        onTargetDevice: 0,
        offTargetDevice: 0,
        lampDevice: 0,
        onLampDevice: 0,
        offLampDevice: 0,
        seedDevice: 0,
        seedShow: true,
        deviceIdList: [],
        pestDeviceList: [],
        sporeDeviceList: [],
        mouseDeviceList: [],
        targetDeviceList: [],
        lampDeviceList: [],
      }
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      this.customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;

      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, this.customerId, function (deviceList) {//获取设备列表
        if(deviceList.data.length > 0) {
          for(let i = 0; i < deviceList.data.length; i++) {
            let deviceId = {};
            deviceId.id = deviceList.data[i].id.id;
            deviceId.name = deviceList.data[i].name;
            deviceId.type = deviceList.data[i].id.entityType;
            that.deviceIdList.push(deviceId);
          }
          that.getDeviceInfo(0, that.deviceIdList.length);//获取每一个设备信息
        } else if( localStorage.getItem('insectToken') != null){
          //that.getXCDeviceList(); //获取祥辰设备
          that.getInsectsDevice();
        } else if(localStorage.getItem('spToken') != null) {
          that.getSPDeviceList();
        }
      })
    },

    methods: {
      /**
       * 使用递归获取每一个设备信息
       * @param j
       * @param length
       */
      getDeviceInfo(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.deviceIdList[j].id, function (deviceInfo) {//获取设备信息
          that.deviceIdList[j].deviceInfo = deviceInfo;
          if(++j < length) {
            that.getDeviceInfo(j, length) //使用递归获取每一个设备信息
          } else {
            that.getDeviceKeyInfo(0, that.deviceIdList.length);//获取每隔设备key属性
          }
        })
      },

      /**
       * 使用递归获取每一个设备的key属性
       * @param j
       * @param length
       */
      getDeviceKeyInfo(j, length) {
        let that = this;
        this.$MeteSoilCommon.getDeviceKeyList(this.deviceIdList[j].deviceInfo, function (keyData) {//获取设备key
          that.deviceIdList[j].keyList = keyData;
          if(++j < length) {
            that.getDeviceKeyInfo(j, length)//使用递归获取每一个设备的key属性
          } else {
            that.getSoilMeteNum(0, that.deviceIdList.length); //获取设备状态
          }
        })
      },

      /**
       * 使用递归判断每个设备是否在线
       * @param j
       * @param length
       */
      getSoilMeteNum(j, length) {
        let that = this;
        let beforeTime = new Date(moment().subtract(1, "hours")).getTime();//一小时前时间戳
        this.$MeteSoilCommon.getLastConnectTime(this.deviceIdList[j].type, this.deviceIdList[j].id).then(lastTime => {
          //总设备状态
          if(beforeTime < lastTime) {
            that.onTotalDevice++;//总在线设备
          } else {
            that.offTotalDevice++;//总离线设备
          }

          //筛选非墒情属性并获取气象设备状态
          let keyList = that.deviceIdList[j].keyList.split(',');
          let strKey = '';
          //筛选非墒情属性
          for(let i = 0; i < keyList.length; i++) {
            if(keyList[i].indexOf('soil') < 0 && keyList[i].indexOf('fxd_') < 0 && keyList[i].indexOf('min_') < 0 && keyList[i].indexOf('null_data') < 0) {
              i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ','
            }
          }

          //获取每个气象设备的状态
          if(strKey != '') {
            that.meteDevice++; //气象总设备数量
            if(beforeTime < lastTime) {
              that.onMeteDevice++; //气象在线设备数量
            } else {
              that.offMeteDevice++; //气象离线设备数量
            }
          }

          // if(that.deviceIdList[j].keyList.indexOf('soil') < 0) {
          //   that.meteDevice++;
          //   if(beforeTime < lastTime) {
          //     that.onMeteDevice++;
          //   } else {
          //     that.offMeteDevice++;
          //   }
          // }

          //墒情设备在线状态
          if(that.deviceIdList[j].keyList.indexOf('soil') >= 0) {
            that.soilDevice++;//墒情总设备数量
            if(beforeTime < lastTime) {
              that.onSoilDevice++; //墒情在线设备数量
            } else {
              that.offSoilDevice++; //墒情离线涉笔数量
            }
          }

          if(that.deviceIdList[j].keyList.indexOf("fxd_") >= 0 ||  that.deviceIdList[j].keyList.indexOf("min_") >= 0 || that.deviceIdList[j].keyList.indexOf("null_data") >= 0) {

            that.fxscdDevice++;
            if(beforeTime < lastTime) {
              that.onFxscdDevice++;
            } else {
              that.offFxscdDevice++;
            }
          }

          if(++j < length) {
            that.getSoilMeteNum(j, length) //使用递归判断每隔设备是否在线
          } else {
            that.totalDevice = that.deviceIdList.length;//总设备

            if(that.meteDevice > 0) {
              let meteJson = {"name": '气象设备', "deviceName": '设备数', "deviceNum": that.meteDevice, "onLineName": '在线设备', "onLineNum": that.onMeteDevice, "offLineName": '离线设备', "offLineNum": that.offMeteDevice};
              //that.leftData.push(meteJson);
              that.leftData.length < 2 ? that.leftData.push(meteJson) : that.rightData.push(meteJson);

            }

            if(that.soilDevice > 0) {
              let soilJson = {"name": '墒情设备', "deviceName": '设备数', "deviceNum": that.soilDevice, "onLineName": '在线设备', "onLineNum": that.onSoilDevice, "offLineName": '离线设备', "offLineNum": that.offSoilDevice};
              //that.leftData.push(soilJson);
              that.leftData.length < 2 ? that.leftData.push(soilJson) : that.rightData.push(soilJson);
            }

            if(that.fxscdDevice > 0) {
              let lampJson = {"name": '杀虫灯设备', "deviceName": '设备数', "deviceNum": that.fxscdDevice, "onLineName": '在线设备', "onLineNum": that.onFxscdDevice, "offLineName": '离线设备', "offLineNum": that.offFxscdDevice};
              //that.rightData.push(lampJson);
              that.leftData.length < 2 ? that.leftData.push(lampJson) : that.rightData.push(lampJson);
            }
            that.getSeedNum(0, that.deviceIdList.length);
          }
        })
      },

      /**
       * 使用递归获取每个设备下的摄像头数量（苗情数量）
       * @param j
       * @param length
       */
      getSeedNum(j, length) {
        getAttributesShared(this.deviceIdList[j].deviceInfo.entityType, this.deviceIdList[j].deviceInfo.id).then(response => {//访问服务端api
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].key.toString().indexOf('vedio') !== -1) {//判断是否有摄像头
              this.seedDevice++;//累计摄像头数量
            }
          }
          if(++j < length) {
            this.getSeedNum(j, length);// 使用递归获取每个设备下的摄像头数量（苗情数量）
          } else {
            if(this.seedDevice > 0) {
              this.seedShow = true;
            }
            this.$emit("soilMeteCount",this.seedDevice, this.meteDevice, this.soilDevice, this.fxscdDevice); //传递摄像头数量 气象设备数量  墒情设备数量
            if(localStorage.getItem('insectToken') != null){
              this.getInsectsDevice();
            } else if( localStorage.getItem('spToken') != null) {
              this.getSPDeviceList();
            }

          }
        }).catch(error => {
          console.log("error", error)
        });
      },

      getInsectsDevice() {
        let token = this.$commonFun.unCompileStr(localStorage.getItem('insectToken'));
        insectDevice(token).then(response => {
          if(response.data.code == 0){
            for(let i = 0; i < response.data.data.length; i++) {
              this.totalDevice++;
              this.pestDevice++;
              if(response.data.data[i].onlineStatus == '在线') {
                this.onTotalDevice++;
                this.onPestDevice++;
              } else {
                this.offTotalDevice++;
                this.offPestDevice++;
              }
            }

            let pestjson = {"name": '虫情设备', "deviceName": '设备数', "deviceNum": this.pestDevice, "onLineName": '在线设备', "onLineNum": this.onPestDevice, "offLineName": '离线设备', "offLineNum": this.offPestDevice};
            //this.rightData.push(pestjson);
            this.leftData.length < 2 ? this.leftData.push(pestjson) : this.rightData.push(pestjson);
            this.$emit("insectCount",this.pestDevice);
            this.$refs.mapData.getInsectDetail(response);
          }
        }).catch(error => {
          console.log("error", error);
        })
        if(localStorage.getItem('spToken') != null) {
          this.getSPDeviceList();
        }
      },

      getSPDeviceList() {
        let that = this;
        this.$SporePestCommon.getSpDeviceList(function (spDeviceList) {
          if(spDeviceList.code != 2000){
            for(let i = 0; i < spDeviceList.data.length; i++) {
              if(spDeviceList.data[i].deviceType == 'spore') {
                let sporeJson = {};
                sporeJson.deviceAddr = spDeviceList.data[i].deviceAddr;
                sporeJson.deviceName =  spDeviceList.data[i].deviceName;
                sporeJson.deviceType =  spDeviceList.data[i].deviceType;
                that.sporeDeviceList.push(sporeJson);
              }
            }
            if(that.sporeDeviceList.length > 0) {
              that.getSporeDetailNum(0, that.sporeDeviceList.length)
            }
          } else {
            that.$message({
              showClose: true,
              type: 'warning',
              message: '出现错误，请稍后再试'
            })
          }
        })
      },

      getSporeDetailNum(j, length) {
        let that = this;
        this.$SporePestCommon.spRealDataTime(this.sporeDeviceList[j].deviceAddr, function (sporeList) {
          if(sporeList.code != 1005) {
            for(let i = 0; i < sporeList.data.length; i++) {
              that.totalDevice++;
              that.sporeDevice++;
              if(sporeList.data[i].status == 'online'){
                that.onTotalDevice++;
                that.onSporeDevice++
              } else { //虫情离线
                that.offTotalDevice++;
                that.offSporeDevice++;
              }
            }

            if(sporeList.data.length == 0) {
              that.totalDevice++;
              that.sporeDevice++;
              that.offTotalDevice++;
              that.offSporeDevice++;
              that.sporeArray.push(that.sporeDeviceList[j]);
            } else {
              that.sporeArray.push(sporeList);
            }

            if(++j < length) {
              that.getSporeDetailNum(j, length);
            } else {
              //将孢子信息写入json
              let json = {"name": '孢子设备', "deviceName": '设备数', "deviceNum": that.sporeDevice, "onLineName": '在线设备', "onLineNum": that.onSporeDevice, "offLineName": '离线设备', "offLineNum": that.offSporeDevice};
              //that.rightData.push(json);
              that.leftData.length < 2 ? that.leftData.push(json) : that.rightData.push(json);
              that.$emit("sporeCount",that.sporeDevice);
              that.$refs.mapData.getSporeDetail(that.sporeArray);
            }
          } else {
            that.$message({
              showClose: true,
              type: 'warning',
              message: '访问过于频繁，请稍后再试'
            })
          }
        })
      },


      /**
       * 获取用户下祥辰设备
       */
      // getXCDeviceList() {
      //   let that = this;
      //   this.$MeteSoilCommon.getCustomerData(this.customerId, function (response) {
      //     for(let i = 0; i < response.data.length; i++) {
      //       if(response.data[i].key.toString().indexOf('pest') > -1){ //虫情
      //         let jsonPest = JSON.parse(response.data[i].value);
      //         that.pestDeviceList.push(jsonPest.name);
      //       } else if(response.data[i].key.toString().indexOf('spore') > -1) { //孢子
      //         let jsonSpore = JSON.parse(response.data[i].value);
      //         that.sporeDeviceList.push(jsonSpore.name);
      //       } else if(response.data[i].key.toString().indexOf('mouse') > -1) { //鼠情
      //         let jsonMouse = JSON.parse(response.data[i].value);
      //         that.mouseDeviceList.push(jsonMouse.name);
      //       } else if(response.data[i].key.toString().indexOf('target') > -1) { //靶标
      //         let jsonTarget = JSON.parse(response.data[i].value);
      //         that.targetDeviceList.push(jsonTarget.name);
      //       } else if(response.data[i].key.toString().indexOf('lamp') > -1) { //杀虫灯
      //         let jsonLamp = JSON.parse(response.data[i].value);
      //         that.lampDeviceList.push(jsonLamp.name);
      //       }
      //     }
      //     if(that.pestDeviceList.length > 0) {// 存在虫情设备
      //       that.getPestNum(0, that.pestDeviceList.length); //使用递归获取每个虫情设备的状态
      //     } else if(that.sporeDeviceList.length > 0) { //存在孢子设备
      //       that.getSporeNum(0, that.sporeDeviceList); //使用递归获取每个孢子设备的状态
      //     } else if(that.mouseDeviceList.length > 0) { //存在鼠情设备
      //       that.getMouseNum(0, that.mouseDeviceList.length);//使用递归获取每个鼠情设备的状态
      //     } else if(that.targetDeviceList.length > 0) {//存在靶标设备
      //       that.getTargetNum(0, that.targetDeviceList.length); //使用递归获取每个靶标设备的状态
      //     } else if(that.lampDeviceList.length > 0) { //存在杀虫灯设备
      //       that.getLampNum(0, that.lampDeviceList.length); //使用递归获取每个杀虫灯设备的状态
      //     }
      //   })
      // },

      /**
       * 使用递归获取每个虫情设备的状态
       * @param j
       * @param length
       */
      // getPestNum(j, length) {
      //   // {"name": '鼠情设备', "deviceName": '设备数', "deviceNum": 0, "onLineName": '在线设备', "onLineNum": 0, "offLineName": '离线设备', "offLineNum": 0}
      //   pestDeviceState(this.pestDeviceList[j]).then(response => { //获取每隔虫情设备状态
      //     // this.deviceState = response.data.data.online == 1 ? '在线' : '离线';
      //     this.totalDevice++;
      //     this.pestDevice++;
      //     if(response.data.data.online == 1) { //虫情在线
      //       this.onTotalDevice++;
      //       this.onPestDevice++;
      //     } else { //虫情离线
      //       this.offTotalDevice++;
      //       this.offTotalDevice++;
      //     }
      //
      //     if(++j < length) {
      //       this.getPestNum(j, length); //使用递归获取每个虫情设备的状态
      //     } else {
      //       //将虫情信息写入json
      //       let json = {"name": '虫情设备', "deviceName": '设备数', "deviceNum": this.pestDevice, "onLineName": '在线设备', "onLineNum": this.onPestDevice, "offLineName": '离线设备', "offLineNum": this.offPestDevice};
      //       this.rightData.push(json);
      //
      //       if(this.sporeDeviceList.length > 0) { //使用递归获取每个孢子设备的状态
      //         this.getSporeNum(0, this.sporeDeviceList.length)
      //       } else if(this.mouseDeviceList.length > 0) { //使用递归获取每个鼠情设备的状态
      //         this.getMouseNum(0, this.mouseDeviceList.length);
      //       } else if(this.targetDeviceList.length > 0) { //使用递归获取每个靶标设备的状态
      //         this.getTargetNum(0, this.targetDeviceList.length);
      //       } else if(this.lampDeviceList.length > 0) { //使用递归获取每个杀虫灯设备的状态
      //         this.getLampNum(0, this.lampDeviceList.length);
      //       }
      //     }
      //   }).catch(error => {
      //     console.log("error", error)
      //   })
      // },

      /**
       * 用递归获取每个孢子设备的状态
       * @param j
       * @param length
       */
      // getSporeNum(j, length) {
      //   let that = this;
      //   this.$SporePestCommon.getDeviceState(that.sporeDeviceList[j], function (response) {
      //     that.totalDevice++;
      //     that.sporeDevice++;
      //     if(response.status == 1) { //每个孢子设备在线状态
      //       that.onTotalDevice++;
      //       that.onSporeDevice++
      //     } else { //每个孢子设备离线状态
      //       that.offTotalDevice++;
      //       that.offSporeDevice++;
      //     }
      //     if(++j < length) {
      //       that.getSporeNum(j, length);
      //     } else {
      //       //将孢子信息写入json
      //       let json = {"name": '孢子设备', "deviceName": '设备数', "deviceNum": that.sporeDevice, "onLineName": '在线设备', "onLineNum": that.onSporeDevice, "offLineName": '离线设备', "offLineNum": that.offSporeDevice};
      //       that.rightData.push(json);
      //
      //       if(that.mouseDeviceList.length > 0) { //使用递归获取每个鼠情设备的状态
      //         that.getMouseNum(0, that.mouseDeviceList.length);
      //       } else if(that.targetDeviceList.length > 0) { //使用递归获取每个靶标设备的状态
      //         that.getTargetNum(0, that.targetDeviceList.length);
      //       } else if(that.lampDeviceList.length > 0) { //使用递归获取每个杀虫灯设备的状态
      //         that.getLampNum(0, that.lampDeviceList.length);
      //       }
      //     }
      //   })
      // },

      /**
       * 使用递归获取每个鼠情设备的状态
       * @param j
       * @param length
       */
      // getMouseNum(j, length) {
      //   // {"name": '鼠情设备', "deviceName": '设备数', "deviceNum": 0, "onLineName": '在线设备', "onLineNum": 0, "offLineName": '离线设备', "offLineNum": 0}
      //   let that = this;
      //   this.$SporePestCommon.getDeviceState(that.mouseDeviceList[j], function (response) {
      //     that.totalDevice++;
      //     that.mouseDevice++;
      //     if(response.status == 1) { //每个鼠情设备在线状态
      //       that.onTotalDevice++;
      //       that.onMouseDevice++;
      //     } else { //每个鼠情设备离线状态
      //       that.offTotalDevice++;
      //       that.offMouseDevice++;
      //     }
      //     if(++j < length) {
      //       that.getMouseNum(j, length);
      //     } else {
      //       //将鼠情信息写入json
      //       let json = {"name": '鼠情设备', "deviceName": '设备数', "deviceNum": that.mouseDevice, "onLineName": '在线设备', "onLineNum": that.onMouseDevice, "offLineName": '离线设备', "offLineNum": that.offMouseDevice};
      //       that.rightData.push(json);
      //
      //       if(that.targetDeviceList.length > 0) {//使用递归获取每个靶标设备的状态
      //         that.getTargetNum(0, that.targetDeviceList.length);
      //       } else if(that.lampDeviceList.length > 0) {//使用递归获取每个杀虫灯设备的状态
      //         that.getLampNum(0, that.lampDeviceList.length);
      //       }
      //     }
      //   })
      // },

      /**
       * 用递归获取每个靶标设备的状态
       * @param j
       * @param length
       */
      // getTargetNum(j, length) {
      //   let that = this;
      //   this.$SporePestCommon.getDeviceState(that.targetDeviceList[j], function (response) {
      //     that.totalDevice++;
      //     that.targetDevice++;
      //     if(response.status == 1) {//每个靶标设备在线状态
      //       that.onTotalDevice++;
      //       that.onTargetDevice++
      //     } else { //每个靶标设备离线状态
      //       that.offTotalDevice++;
      //       that.offTargetDevice++
      //     }
      //
      //     if(++j < length) {
      //       that.getTargetNum(j, length);
      //     } else {
      //       //将靶标信息写入json
      //       let json = {"name": '靶向害虫设备', "deviceName": '设备数', "deviceNum": that.targetDevice, "onLineName": '在线设备', "onLineNum": that.onTargetDevice, "offLineName": '离线设备', "offLineNum": that.offTargetDevice};
      //       that.rightData.push(json);
      //
      //       if(that.lampDeviceList.length > 0) { //使用递归获取每个杀虫灯设备的状态
      //         that.getLampNum(0, that.lampDeviceList.length);
      //       }
      //     }
      //   })
      // },

      /**
       * 用递归获取每个杀虫灯设备的状态
       * @param j
       * @param length
       */
      // getLampNum(j, length) {
      //   let that = this;
      //   this.$SporePestCommon.getDeviceState(that.lampDeviceList[j], function (response) {
      //     that.totalDevice++;
      //     that.lampDevice++;
      //     if(response.status == 1) {//每个杀虫灯设备在线状态
      //       that.onTotalDevice++;
      //       that.onLampDevice++
      //     } else {//每个杀虫灯设备离线状态
      //       that.offTotalDevice++;
      //       that.offLampDevice++;
      //     }
      //
      //     if(++j < length) {
      //       that.getLampNum(j,  length);
      //     } else {
      //       //将杀虫灯信息写入json
      //       let lampJson = {"name": '杀虫灯设备', "deviceName": '设备数', "deviceNum": that.lampDevice, "onLineName": '在线设备', "onLineNum": that.onLampDevice, "offLineName": '离线设备', "offLineNum": that.offLampDevice};
      //       that.leftData.push(lampJson);
      //     }
      //   })
      // }
    }
  }
</script>

<style lang="less">
  @import "../less/MainScreen";
</style>

<style>
  .main-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/MainScreen.vue